import { useState, useEffect, useCallback } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import { X } from "lucide-react";

export function ComplaintTemplates({ scope, onApply, current, clientId = "", testId }) {
  const [tpls, setTpls] = useState([]);

  const load = useCallback(() => {
    api.get("/complaint-templates", { params: { client_id: clientId || "" } })
      .then((r) => setTpls((r.data || []).filter((t) => t.scope === scope)))
      .catch(() => {});
  }, [scope, clientId]);
  useEffect(() => { load(); }, [load]);

  const save = async () => {
    const title = window.prompt("Titel voor dit sjabloon?");
    if (!title || !title.trim()) return;
    let forClient = "";
    if (clientId) {
      forClient = window.confirm("Alleen voor deze opdrachtgever opslaan?\n\nOK = alleen deze opdrachtgever · Annuleren = voor alle opdrachtgevers") ? clientId : "";
    }
    try {
      await api.post("/complaint-templates", { scope, title: title.trim(), subject: current?.subject || "", body: current?.body || "", client_id: forClient });
      toast.success(forClient ? "Sjabloon opgeslagen (opdrachtgever)" : "Sjabloon opgeslagen");
      load();
    } catch { toast.error("Opslaan mislukt"); }
  };
  const del = async (id, e) => {
    e.stopPropagation();
    try { await api.delete(`/complaint-templates/${id}`); load(); } catch { toast.error("Verwijderen mislukt"); }
  };

  return (
    <div className="flex flex-wrap items-center gap-1.5" data-testid={testId}>
      <span className="text-[11px] text-slate-400">Sjablonen:</span>
      {tpls.map((t) => (
        <span key={t.id} className={`inline-flex items-center rounded-full border text-xs overflow-hidden group ${t.client_id ? "bg-amber-50 border-amber-200" : "bg-white"}`}>
          <button type="button" onClick={() => onApply(t)} className="pl-2.5 pr-1.5 py-0.5 text-slate-600 hover:text-rose-600 transition-colors" data-testid={`ctpl-apply-${t.id}`}>{t.title}{t.client_id ? " ★" : ""}</button>
          <button type="button" onClick={(e) => del(t.id, e)} className="pr-1.5 text-slate-300 hover:text-red-500" title="Verwijderen" data-testid={`ctpl-del-${t.id}`}><X className="h-3 w-3" /></button>
        </span>
      ))}
      <button type="button" onClick={save} className="px-2 py-0.5 rounded-full text-xs border border-dashed border-slate-300 text-slate-500 hover:text-rose-600 hover:border-rose-300 transition-colors" data-testid={`${testId}-save`}>+ Opslaan</button>
    </div>
  );
}
